import styled from '@emotion/styled';
import { color } from 'components/core/theme';
import { mediaMobile } from 'components/core/theme/breakpoints';

export const Board = styled.div`
  display: grid;
  position: fixed;
  height: calc(100% - 140px);
  max-width: 100%;
  overflow: auto;
  grid-template-areas: 'list view';
  min-height: 0;
  min-width: 0;

  > * + * {
    border-left: 1px solid grey;
  }

  ${mediaMobile} {
    > * + * {
      border-left: none;
    }
  }
`;

export const ApptList = styled.div`
  grid-area: list;
  min-width: 600px;
  max-width: 1000px;
  padding-left: 120px;
  padding-top: 120px;
  min-width: 0;
  overflow: auto;

  ${mediaMobile} {
    min-width: inherit;
    padding: 12px;
  }
`;

export const ApptView = styled.div<{ shouldHide?: boolean }>`
  grid-area: view;
  width: 505px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  padding: 12px;
  min-width: 0;
  overflow: auto;

  ${mediaMobile} {
    display: ${(props) => (props.shouldHide ? 'none' : 'flex')};
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    grid-area: clear;
    padding: 0px;

    width: calc(100% - 24px);
  }
`;

export const ScheduleBarDesktop = styled.div<{ selected?: boolean }>`
  display: flex;
  justify-content: space-between;
  background-color: ${(props) => (props.selected ? color('greenLight') : 'unset')};

  padding: 8px 24px 8px 24px;
  cursor: pointer;

  > .left {
    display: flex;
    flex-direction: row;

    > div {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }

  > .right {
    display: flex;
    align-items: center;
  }

  ${mediaMobile} {
    display: none !important;
  }
`;

export const ScheduleBarMobile = styled.div<{ selected?: boolean }>`
  ${mediaMobile} {
    ${(props) => (props.selected ? `background-color: ${color('greenLight')};` : '')}
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 16px 16px 0;
  }

  display: none;
`;

export const AlignCenter = styled.div`
  display: flex;
  align-items: center;
`;

export const AppointmentsContainer = styled.div`
  margin: 32px 0;

  ${mediaMobile} {
    margin: 20px 0;
  }
`;
